import { render, staticRenderFns } from "./MessageTip.vue?vue&type=template&id=4828b8f2&scoped=true&"
import script from "./MessageTip.vue?vue&type=script&lang=ts&"
export * from "./MessageTip.vue?vue&type=script&lang=ts&"
import style0 from "./MessageTip.vue?vue&type=style&index=0&id=4828b8f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4828b8f2",
  null
  
)

export default component.exports